import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { getRequestOnServer } from '#src/functions/getRequestOnServer.ts';
import { OrganizationPage } from '#src/pages/OrganizationPage/index.ts';
import { ssrWhenNotAuthenticated } from '#src/utils/tanstackRouterUtil.ts';

export const Route = createFileRoute('/{-$locale}/organization_/$orgId')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { locale, orgId } = params;
    const request = getRequestOnServer();
    await queryClient.ensureQueryData(orgQueryOptions({ locale, request, orgId }));
  },
  ssr: ssrWhenNotAuthenticated
});

function RouteComponent() {
  const { locale, orgId } = Route.useParams();

  const query = useSuspenseQuery(orgQueryOptions({ locale, orgId }));
  const organization = query.data.data;

  return <OrganizationPage organization={organization} />;
}

function orgQueryOptions({
  locale,
  request,
  orgId
}: {
  locale?: string;
  request?: Request;
  orgId: string;
}) {
  return getReactQueryOptions(
    publicApiQueryClient.organizations.get,
    { params: { id: orgId } },
    { context: { locale, request } }
  );
}
